import React, { useState, useEffect, useRef } from 'react';
import { Icon as Iconify } from '@iconify/react';
import { lionIcons } from '../components/helpersIcons';



const MultiSelectDropdown = ({ items = [], selected = [], onChange, error = '' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (selected && selected !== null && selected.length > 0) {
      setSelectedItems(selected)
    }
  }, [selected])

  const toggleDropdown = () => setIsOpen(prev => !prev);

  const handleSelect = (item) => {
    const prev = selectedItems;
    const newItems = prev.includes(item) ? prev.filter(i => i !== item) : [...prev, item]
/*
    setSelectedItems(prev =>
      prev.includes(item) ? prev.filter(i => i !== item) : [...prev, item]
    );
*/
    setSelectedItems(newItems)
    if (onChange) onChange(newItems)
  };

  const handleRemove = (item) => {
    const prev = selectedItems;
    const newItems = prev.filter(i => i !== item)

    setSelectedItems(newItems);
    if (onChange) onChange(newItems)
};

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="relative w-64" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className="w-full flex justify-between items-center bg-white border border-gray-300 p-2 rounded-xl shadow-sm"
      >
        <div className="flex flex-wrap gap-1">
          {selectedItems.length === 0 ? (
            <span className="text-gray-500">Select options</span>
          ) : (
            selectedItems.map(item => (
              <div
                key={item}
                className="flex flex-row items-center bg-ccColorTeal text-white text-sm font-semibold px-2 py-1 rounded-full"
              >
                <div>{item}</div>
                <div className="ml-1 cursor-pointer" onClick={(e) => { e.stopPropagation(); handleRemove(item); }}><Iconify icon="ic:round-cancel" width={20} /></div>
              </div>
            ))
          )}
        </div>
        <Iconify icon="ci:chevron-down" />
        </button>
        {error.length > 0 && <div className='ml-2 flex flex-row items-center gap-x-1 text-red-600'>
            <Iconify icon="ep:warning-filled" width={18} />
            <div className='text-sm'>{error}</div>
          </div>}

      {isOpen && (
        <div className="absolute mt-2 w-full z-10 bg-white border border-gray-200 rounded-xl shadow-md max-h-60 overflow-auto">
          <ul className="p-2">
            {items.map(item => (
              <li
                key={item}
                onClick={() => handleSelect(item)}
                className={`cursor-pointer px-4 py-2 rounded hover:bg-ccColorTeal hover:text-white ${selectedItems.includes(item) ? 'bg-ccColorLightTeal' : ''}`}
              >
                {item}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;
